import { ReactElement } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';

const OfficerProfile = (): ReactElement => {
  const { user } = useAuth();
  return (
    <div className="bg-white rounded-lg shadow p-4 space-y-3">
  <div className="text-sm text-gray-500">Name</div>
  <div className="font-semibold">{user?.name}</div>

  <div className="text-sm text-gray-500 mt-3">Email</div>
  <div className="font-semibold">{user?.email}</div>

  <Link
    to="/profile/settings"
    className="mt-4 btn-primary w-full inline-block text-center"
  >
    Change Settings / Password
  </Link>
</div>
  );
};

export default OfficerProfile;


